import type { GetOversightAssessmentByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOversightAssessmentByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetOversightAssessmentByIdArgs = {
  id: string;
};

/**
 * Eager twin of `useLazyGetOversightAssessmentById` — same tRPC procedure and
 * mapper, for the pages that read the assessment on mount rather than on
 * demand (the lazy variant serves the exporter).
 */
export const useGetOversightAssessmentById = createQueryHook<
  UseGetOversightAssessmentByIdArgs,
  GetOversightAssessmentByIdResponseRow[],
  GetOversightAssessmentByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.oversight.getById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ oversight_assessment: data }),
  graphqlDocument: GetOversightAssessmentByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
